<template>
  <teleport to="body">
    <jet-dialog-modal id="track-shipping-modal">
      <template #title>Package Tracking</template>
      <template #content>
        <div v-if="events">
          <table width="100%">
            <tr>
              <th></th>
              <th></th>
              <th></th>
            </tr>
            <tr v-for="track in events" :key="track.id">
              <td>{{ moment(track.event_date).format('M/D/YY h:mm A') }} </td>
              <td>{{ track.event_description }} </td>
              <td v-if="track.event_city && track.event_city.length > 0">
                {{ track.event_city }}, {{ track.event_state }}
              </td>
            </tr>
          </table>
        </div>
      </template>

      <template #footer>
        <jet-button @click="hideModal">Close</jet-button>
      </template>
    </jet-dialog-modal>
  </teleport>
</template>

<script>
import JetDialogModal from '@/Jetstream/DialogModal'
import JetButton from '@/Jetstream/Button'
import moment from 'moment'

export default {
  components: {
    JetDialogModal,
    JetButton,
  },
  emits: ['close'],
  props: {
    defaultEvents: {
      default: [],
      type: Array,
    },
    shipmentId: Number,
  },
  data() {
    return {
      events: [],
    }
  },
  created() {
    this.moment = moment;
    let component = this;
    $(document).on('hide.bs.modal', '#track-shipping-modal', function () {
      component.$emit('close');
    });
  },
  watch: {
    shipmentId (value) {
      if (value) {
        this.showModal();
      } else {
        this.hideModal();
      }
    },
    defaultEvents (value) {
      if (value) {
        this.events = value;
        this.showModal();
      } else {
        this.hideModal();
      }
    }
  },
  methods: {
    showModal() {
      if (this.shipmentId) {
        axios
          .get(route('shipments.events', this.shipmentId))
          .then((resp) => {
            if (resp.data.success && resp.data.events.length > 0) {
              this.events = resp.data.events;
              $('#track-shipping-modal').modal('show');
            } else {
              this.events = null;
            }
          });
      } else {
        $('#track-shipping-modal').modal('show');
      }
    },
    hideModal() {
      this.events = null;
      $('#track-shipping-modal').modal('hide');
    }
  },
}
</script>
